import { useEffect, useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { publicOrgService } from '@/services/publicOrg';

const spinner = (
  <div className="flex min-h-[200px] items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900 dark:border-white" />
  </div>
);

/**
 * Redirects legacy /academy/:academySlug/* URLs to /club-academy/:orgSlug/*.
 */
export function LegacyAcademyToOrgRedirect() {
  const location = useLocation();
  const { academySlug, '*': rest } = useParams<{ academySlug: string; '*': string }>();
  const [orgSlug, setOrgSlug] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    if (!academySlug) {
      return undefined;
    }
    let mounted = true;
    void publicOrgService.resolveOrgSlugFromAcademySlug(academySlug).then((slug) => {
      if (mounted) setOrgSlug(slug);
    });
    return () => {
      mounted = false;
    };
  }, [academySlug]);

  if (!academySlug) {
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center">
        <h1 className="text-xl font-semibold">Academy not found</h1>
      </div>
    );
  }

  if (orgSlug === undefined) return spinner;
  if (!orgSlug) {
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center">
        <h1 className="text-xl font-semibold">Academy not found</h1>
      </div>
    );
  }

  const suffix = rest ? `/${rest}` : '';
  return (
    <Navigate
      to={`/club-academy/${orgSlug}${suffix}${location.search}${location.hash}`}
      replace
    />
  );
}
